/**
 * @generated SignedSource<<cdb911f6b0a4a75a79d7986edfd85584>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MultiSelectFieldFragment$data = {
  readonly id: string;
  readonly options: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"MultiSelectFieldOptionFragment">;
  }> | null | undefined;
  readonly " $fragmentType": "MultiSelectFieldFragment";
};
export type MultiSelectFieldFragment$key = {
  readonly " $data"?: MultiSelectFieldFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MultiSelectFieldFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MultiSelectFieldFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectV2MultiSelectFieldOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "MultiSelectFieldOptionFragment",
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectV2ItemFieldMultiSelectValue",
  "abstractKey": null
};
})();

(node as any).hash = "f7472479b0b14c2b5357205d9075ed5b";

export default node;
